import React from 'react';
import { Scale, Shield, Award, Users } from 'lucide-react';

const WhyChooseUsSection = () => {
  const reasons = [
    {
      icon: Scale,
      title: 'Proven Track Record',
      description: 'A demonstrated history of successful outcomes across all practice areas.',
    },
    {
      icon: Shield,
      title: 'Trusted Expertise',
      description: 'Deep legal experience protecting businesses nationwide with specialized expertise.',
    },
    {
      icon: Award,
      title: 'Industry Recognition',
      description: 'Award-winning legal team recognized for excellence and client satisfaction.',
    },
    {
      icon: Users,
      title: 'Client-Focused',
      description: 'Personalized attention and tailored strategies for your unique legal needs.',
    },
  ];

  return (
    <section className="py-24 md:py-32 bg-white" data-testid="why-choose-us-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <div className="text-sm uppercase tracking-[0.2em] font-medium text-[#CA9A67] mb-4">
            Why Choose Us
          </div>
          <h2 className="text-3xl lg:text-4xl tracking-tight text-[#2E2E2E] font-bold mb-4">
            Your Trusted Legal Partner
          </h2>
          <p className="text-base leading-relaxed text-[#2E2E2E]/80 max-w-2xl mx-auto">
            We combine legal expertise with practical business insight to deliver exceptional results for our clients.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mobile-swiper">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div
                key={index}
                className="bg-white border border-[#2C3E50]/5 shadow-sm hover:shadow-md transition-all duration-300 p-8 text-center group hover:-translate-y-1"
                data-testid={`reason-${index}`}
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#CA9A67]/10 mb-6 group-hover:bg-[#CA9A67] transition-colors">
                  <Icon className="w-8 h-8 text-[#CA9A67] group-hover:text-white transition-colors" strokeWidth={1.5} />
                </div>
                <h3 className="text-xl text-[#2C3E50] font-semibold mb-3">{reason.title}</h3>
                <p className="text-sm text-[#2E2E2E]/70 leading-relaxed">{reason.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
